// extracted by mini-css-extract-plugin
export default {"root":"XrF_n","value":"_33gAW","button":"_3WSVq"};